import React, { useEffect, useMemo } from 'react';
import { queueMetric } from 'modules/metrics';
import config from 'config';
import { SessionTimeout } from './SessionTimeout';

export const MeSessionTimeout = (): JSX.Element => {
  useEffect(() => {
    if (localStorage.getItem('new-login')) {
      localStorage.removeItem('new-login');
      queueMetric('login-success');
    }
  });
  const allowedDomain = useMemo(
    () => config.allowedSessionDomains.split(','),
    []
  );
  if (
    !window.REPLICON_SKIP_SESSION ||
    allowedDomain.some((domain) => window.location.hostname.endsWith(domain))
  ) {
    return <SessionTimeout />;
  }

  return <></>;
};
